import { Pagination, PaginationProps } from '@/components/atoms/Pagination';
import { Popover } from '@/components/atoms/Popover';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/rootReducer';
import { UserRole } from '@/modules/user/userTypes';
import { useExportBusinessMutation } from './src/hooks/useExportBusinessMutation';
import { useListDetailsFiltersContext } from '../../../providers/ListDetailsFiltersProviders';

export const BusinessPagination = (props: PaginationProps) => {
	const { totalPages } = props;

	const { appliedFilters } = useListDetailsFiltersContext();
	const { mutate } = useExportBusinessMutation({ appliedFilters });

	const [user] = useSelector((state: RootState) => [
		state.user.getIn(['authorize', 'user']).toJS()
	]);

	const handleExportBusinesses = useCallback(
		(contactedOnly: boolean) => {
			mutate(contactedOnly);
		},
		[mutate]
	);

	return (
		<section className="grid grid-cols-[auto_1fr_auto] items-center border-t border-dm-gray p-3">
			{totalPages > 1 && <Pagination {...props} />}

			<div className="col-start-3 flex items-center gap-6">
				{user.role !== UserRole.Free &&
					user.role !== UserRole.PreTrial && (
						<Popover.Root>
							<Popover.Trigger className="w-fit border-none text-sm text-orange">
								Export (first 250 results)
							</Popover.Trigger>

							<Popover.Content className="flex flex-col gap-2">
								<Popover.Button
									onClick={() => handleExportBusinesses(true)}
									className="group/button h-fit"
								>
									<section className="flex w-full flex-col items-center justify-end gap-2">
										<p className="whitespace-normal text-end group-hover/button:text-orange">
											Export information for first 250
											businesses you&apos;ve contacted
										</p>
										<small className="w-full whitespace-normal text-end">
											(email addresses included)
										</small>
									</section>
								</Popover.Button>

								<hr className="w-full bg-dm-gray" />

								<Popover.Button
									onClick={() =>
										handleExportBusinesses(false)
									}
									className="group/button h-fit"
								>
									<section className="flex w-full flex-col items-center justify-end gap-2">
										<p className="whitespace-normal text-end group-hover/button:text-orange">
											Export information for first 250
											businesses
										</p>
										<small className="w-full whitespace-normal text-end">
											(email addresses excluded)
										</small>
									</section>
								</Popover.Button>
							</Popover.Content>
						</Popover.Root>
					)}
			</div>
		</section>
	);
};
